import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface StyledProps {
  isEdition?: boolean;
}

export const Container = styled.div<StyledProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 40px;
  border-top: solid 1px ${({ theme }) => theme.button.containerBorder};
  border-bottom: solid 1px ${({ theme }) => theme.button.containerBorder};

  @media ${({ theme }) => theme.device.mobile} {
    margin-bottom: ${({ isEdition }) => isEdition && '100px'};
  }
`;

export const StyledButton = styled.button`
  background-color: ${ColorPalette.Transparent};
  cursor: pointer;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  color: ${({ theme }) => theme.button.invertedColor};
`;

export const TrashIcon = styled.img`
  height: 20px;
  width: 20px;
  margin-left: 10px;
`;
